var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.304 13.696 0 7.5 6.196 1.304 0 0 1.304 6.196 7.5 0 13.696 1.304 15 7.5 8.804 13.696 15 15 13.696 8.804 7.5z"
  })));
};
export default SvgClose;